import React, { useContext } from 'react'
import { useSelector } from 'react-redux';
import EditSection from './Edits/EditSection';
import VideoPostForm from './VideoPostForm';
import { VideoContext } from '../../../../../Context/VideoContext';
import LoadingScene from '../../../../../Components/LensLoadingScene/LoadingScene';

function VideoSettings() {
    const videoMenu = useSelector((state) => state.lens.video.menu);

    const { loading } = useContext(VideoContext);

    return (
        <>
            {
                videoMenu === 'edit' && 
                <>
                    {
                        loading ? 
                        <LoadingScene /> : 
                        <EditSection />
                    }
                </>
            }

            {
                videoMenu === 'form' && 
                <>
                    {
                        loading ? 
                        <LoadingScene /> : 
                        <VideoPostForm />
                    }
                </>
            }
        </>
    )
}

export default VideoSettings;
